"use client";
import Hyperlink from "../ui/hyperlink";
import Image from "next/image";

interface Props {
    title: string;
    description: string;
    subtext?: string;
    quote?: string;
    author?: string;
    btn?: string;
    btn1?: string;
    href?: string;
    target?: "_blank" | "_self";
    onModalOpen?: (modalTitle?: string) => void;
}

const Hero2 = ({
    title,
    description,
    btn,
    btn1,
    href,
    target = "_blank",
    onModalOpen
}: Props) => {
    const handleModalOpen = (modalTitle?: string) => {
        if (onModalOpen) {
            onModalOpen(modalTitle);
        }
    };

    return (
        <>
            <section
                className="desilo-hero4-section section-padding-bottom overflow-hidden"
                style={{ 
                    position: 'relative', 
                    background: '#FFF', /* Fallback background */
                    minHeight: '400px'
                }}
            >
                <Image
                    src="/images/hero/desilo.png"
                    alt="Contact Hero Background"
                    fill
                    priority
                    fetchPriority="high"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 1920px"
                    style={{
                        objectFit: 'cover',
                        objectPosition: 'right center',
                        zIndex: 0,
                    }}
                    quality={90}
                />
                
                {/* Gradient Overlay - Layered above image with better performance hint */}
                <div style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(63deg, rgba(255, 212, 163, 0.4) 17.08%, rgba(255, 255, 255, 0.4) 83.17%)',
                    zIndex: 1,
                    pointerEvents: 'none',
                    willChange: 'opacity'
                }} />

                <div className="container custom-container" style={{ position: 'relative', zIndex: 2 }}>
                    <div className="row g-4 justify-content-between align-items-end">
                        <div className="col-lg-12 col-xxl-9">
                            <div className="desilo-hero5__info">
                                <h1 className="title" style={{ position: 'relative' }}>
                                    {title}
                                </h1>
                                <p className="hero2-content-text text-color-primary">
                                    {description}
                                </p>
                                {btn && btn1 && (
                                    <div className="d-md-flex d-block align-items-center gap-4">
                                        <Hyperlink
                                            href={href || "https://calendly.com/parthik/30min"}
                                            variant="primary"
                                            target={target}
                                        >
                                            {btn}
                                        </Hyperlink>
                                        <Hyperlink
                                            variant="modal-pill"
                                            onModalOpen={handleModalOpen}
                                            modalTitle={btn1}
                                            className="text-color-primary d-block cursor-pointer"
                                        >
                                            {btn1}
                                        </Hyperlink>
                                    </div>
                                )}
                                {btn && !btn1 && (
                                    <Hyperlink
                                        href={href || "https://calendly.com/parthik/30min"}
                                        variant="primary"
                                        target={target}
                                    >
                                        {btn}
                                    </Hyperlink>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* {subtext && quote && author && (
                <div className="container custom-container">
                    <div className="row section-margin-top gx-5">
                        <div className="col-12 quate-details-box">
                            <blockquote className="d-flex align-items-start gap-4 service-quote-section mb-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="42" height="34" viewBox="0 0 42 34" fill="none">
                                    <g clipPath="url(#clip0_3257_80348)">
                                        <mask id="mask0_3257_80348" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="42" height="34">
                                            <path d="M42 33.5312L0 33.5312L0 0.53125L42 0.53125L42 33.5312Z" fill="white" />
                                        </mask>
                                        <g mask="url(#mask0_3257_80348)">
                                            <path d="M3.78651 3.40053C1.42857 6.03544 0.0138359 8.90987 0.0138359 13.7006C0.0138359 22.0844 5.9086 29.5101 14.1612 33.3426L16.2833 30.2287C8.50227 25.917 6.85173 20.4077 6.38019 16.8146C7.55913 17.5332 9.20961 17.7728 10.8602 17.5332C15.1044 17.0541 18.4055 13.7006 18.4055 9.14943C18.4055 6.99361 17.4623 4.83775 16.0475 3.161C14.397 1.48424 12.5107 0.765627 10.1528 0.765627C7.55913 0.765627 5.20119 1.96331 3.78651 3.40053ZM27.3654 3.40053C25.0076 6.03543 23.5928 8.90987 23.5928 13.7006C23.5928 22.0844 29.4875 29.5101 37.7402 33.3426L39.8623 30.2287C32.0812 25.917 30.4307 20.4076 29.9591 16.8146C31.1381 17.5332 32.7886 17.7728 34.4391 17.5332C38.6833 17.0541 41.9844 13.7006 41.9844 9.14943C41.9844 6.99361 41.0412 4.83775 39.6265 3.16099C38.2117 1.48424 36.0896 0.765624 33.7317 0.765625C31.1381 0.765625 28.7802 1.9633 27.3654 3.40053Z" fill="#E25926" />
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_3257_80348">
                                            <rect width="42" height="33" fill="white" transform="matrix(-1 0 0 1 42 0.53125)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <div>
                                    <div className="text">
                                        {quote}
                                    </div>
                                    <cite>
                                        ─ {author}
                                    </cite>
                                </div>
                            </blockquote>
                        </div>
                    </div>
                </div>
            )} */}
        </>
    );
};

export default Hero2;
